import type { FlagDto } from '@process-hub/shared';
import { useState } from 'react';
import { formatWhen } from '../time';

/** Reader flags on a process: raise one (readers), resolve (owner). BUILD.md §9. */
export function FlagsPanel({ flags, canFlag, canResolve, onFlag, onResolve, busy }: { flags: FlagDto[]; canFlag: boolean; canResolve: boolean; onFlag: (reason: string) => void; onResolve: (id: string) => void; busy: boolean }) {
  const [reason, setReason] = useState('');
  const [open, setOpen] = useState(false);
  const active = flags.filter((f) => !f.resolvedAt);
  const resolved = flags.filter((f) => f.resolvedAt);

  return (
    <div className="flags">
      <div className="flags__head">
        <strong>Flags</strong>
        <span className="muted">
          {' '}
          · {active.length} open{resolved.length ? `, ${resolved.length} resolved` : ''}
        </span>
        {canFlag && !open && (
          <button type="button" className="link-button" style={{ marginLeft: 'auto' }} onClick={() => setOpen(true)}>
            Flag something wrong
          </button>
        )}
      </div>
      {open && (
        <div className="flags__new">
          <textarea value={reason} onChange={(e) => setReason(e.target.value)} rows={2} maxLength={1000} placeholder="What is wrong or out of date? The owner will read this." />
          <div className="approval__buttons">
            <button type="button" className="button" disabled={busy || reason.trim().length < 5} onClick={() => { onFlag(reason.trim()); setReason(''); setOpen(false); }}>
              Send flag
            </button>
            <button type="button" className="link-button" onClick={() => setOpen(false)}>
              Cancel
            </button>
          </div>
        </div>
      )}
      {active.length > 0 && (
        <ul className="flags__list">
          {active.map((f) => (
            <li key={f.id} className={f.system ? 'flags__item flags__item--system' : 'flags__item'}>
              <span>
                {f.reason}
                <div className="grid__secondary">
                  {f.system ? 'Process Hub' : (f.userName ?? 'A reader')}
                  {f.source ? ` · via ${f.source}` : ''} · {formatWhen(f.createdAt)}
                </div>
              </span>
              {canResolve && (
                <button type="button" className="link-button" disabled={busy} onClick={() => onResolve(f.id)}>
                  Resolve
                </button>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
